import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { FluentProvider, IdPrefixProvider, webLightTheme } from '@fluentui/react-components'
import { MsalShellAuthProvider } from './auth/MsalShellAuthProvider'
import { createShellTelemetry } from './telemetry/shellTelemetry'
import { environment } from './environment'
import App from './App.tsx'
import './index.css'

const telemetry = createShellTelemetry(environment.appInsightConnectionString || undefined)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <IdPrefixProvider value="shell-">
      <FluentProvider theme={webLightTheme} style={{ height: '100vh' }}>
        <MsalShellAuthProvider>
          <BrowserRouter>
            <App telemetry={telemetry} />
          </BrowserRouter>
        </MsalShellAuthProvider>
      </FluentProvider>
    </IdPrefixProvider>
  </StrictMode>,
)
